import { render, staticRenderFns } from "./UploadDetail.vue?vue&type=template&id=242b1cf5&scoped=true"
import script from "./UploadDetail.vue?vue&type=script&lang=js"
export * from "./UploadDetail.vue?vue&type=script&lang=js"
import style0 from "./UploadDetail.vue?vue&type=style&index=0&id=242b1cf5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242b1cf5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VRow,VTextField})
